// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit[data-v-6cfbed40]{width:62.239583rem;margin:0 auto;margin-bottom:.9375rem}.edit-main[data-v-6cfbed40]{background-color:#fff}[data-v-6cfbed40] .el-input{width:15.625rem}[data-v-6cfbed40] .el-breadcrumb__item{padding-top:.520833rem}[data-v-6cfbed40] .el-button{margin-left:13.020833rem;width:15.625rem;margin-top:5.208333rem}.form[data-v-6cfbed40]{padding:5.208333rem 2.604167rem 5.208333rem}.el-breadcrumb__item[data-v-6cfbed40]{font-size:.729167rem}", ""]);
// Exports
module.exports = exports;
